import { Platform, type ModalProps } from "react-native";

/**
 * The orientations a shared React Native `Modal` may rotate to. Pass it as `supportedOrientations`
 * on EVERY `Modal` that renders on the phone. It is v1 mobile's value (`utils/DeviceUtil.isTablet`
 * with release_4.0.0's rotation fix): all four on an iPad, portrait on a phone. On iOS
 * `Platform.isPad` is the same test `react-native-device-info` makes, and the prop is iOS-only
 * (Android ignores it), so no other device check is needed.
 *
 * ⚠️ Never leave the prop out. Omitted, it is PORTRAIT: that is the native component's codegen
 * default, not the "all orientations on an iPad" branch, which only an empty array reaches. This
 * app's iPad plist allows landscape only, so iOS finds no orientation in common: a red box in a
 * dev build, and a crash in release (RN's `RCTFabricModalHostViewController`, "This will crash in
 * non-dev mode"). `ModalOrientations.test.ts` pins every shared `Modal`.
 */
export const MODAL_ORIENTATIONS: ModalProps["supportedOrientations"] =
  Platform.OS === "ios" && Platform.isPad ? ["portrait", "portrait-upside-down", "landscape-left", "landscape-right"] : ["portrait"];
